import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MetOperationService from './met-operation-service';
import MetOperationServiceDetail from './met-operation-service-detail';
import MetOperationServiceUpdate from './met-operation-service-update';
import MetOperationServiceDeleteDialog from './met-operation-service-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={MetOperationServiceUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={MetOperationServiceUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={MetOperationServiceDetail} />
      <ErrorBoundaryRoute path={match.url} component={MetOperationService} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={MetOperationServiceDeleteDialog} />
  </>
);

export default Routes;
